import React from "react";
import { Form } from "react-bootstrap";

const ThirdForm = ({ currentStep, message, setMessage }) => {
  if (currentStep !== 3) {
    return null;
  }
  return (
    <Form.Group className="u-mb-small">
      <Form.Label>Votre Message:</Form.Label>
      <Form.Control
        as="textarea"
        rows={5}
        columns={5}
        value={message}
        placeholder="si vous avez un message a nous faire part, faites le nous savoir ici"
        onChange={(e) => setMessage(e.target.value)}
      />
    </Form.Group>
  );
};

export default ThirdForm;
